import { apiFetch } from "./client";

export const fetchHeroSlides = () =>
  apiFetch("/enduser/hero-slides/");
